(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('CompendiumReportGroup', CompendiumReportGroup);

    CompendiumReportGroup.$inject = ['$resource'];

    function CompendiumReportGroup ($resource) {
        var resourceUrl =  'api/compendium-report-groups/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
